import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=6cc17878&scoped=true&"
import script from "./popup.vue?vue&type=script&lang=js&"
export * from "./popup.vue?vue&type=script&lang=js&"
import style0 from "./index.less?vue&type=style&index=0&id=6cc17878&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc17878",
  null
  
)

export default component.exports